import { Dialog } from '@material-ui/core';
import { BlueInfoIcon } from 'assets/icons';
import { useTranslation } from 'react-i18next';
import DialogCard from './dialogCard';

interface InfoDialogCardProps {
	className?: string;
	icon?: React.FC;
	infoMessage?: string;
	iconTitle?: string;
	successMessage?: string;
	onClose: () => void;
	subTitle?: string;
	cyDescriptionTestRef?: string;
	cyActionTextRef?: string;
}

const InfoDialogCard = (props: InfoDialogCardProps) => {
	const [t] = useTranslation();

	return (
		<Dialog
			maxWidth={'xs'}
			fullWidth
			onClose={() => {}}
			className={`${props.className} custom-dialog bg--transparent custom--box-shadow text--center`}
			aria-labelledby="customized-dialog"
			open={true}
		>
			<DialogCard
				className="info-dialog--card"
				icon={BlueInfoIcon}
				subTitle={props.subTitle}
				iconTitle={props.iconTitle}
				cardBottomText={t('ok')}
				onActionButtonClick={(e: any) => {
					props.onClose();
				}}
				cyDescriptionTestRef={props.cyDescriptionTestRef}
				cyActionTextRef={props.cyActionTextRef}
			/>
		</Dialog>
	);
};

export default InfoDialogCard;
